import React, { useState, useEffect, useLayoutEffect, useContext } from "react";
import { withRouter, Switch, Route } from "react-router-dom";
import { IGroupContainerProps } from "./IGroupContainerProps";
import PublicRoute from "routes/PublicRoute";
import MainLoadingComponent from "components/mainLoading";
import Loadable from "react-loadable";
import SidebarComponent from "components/sidebar";
import SidebarForChannelComponent from "components/sidebar/sidebarForChannel";
import { connect } from "react-redux";
import { Map } from "immutable";
import { getCookieValue, setCookieValue } from "../../utils/cookieStorage";
import PrivateRoute from "routes/PrivateRoute";
import { authorizeActions, globalActions } from "store/actions";
import store from "../../store/configureStore";
import useWindowSize from "utils/windowSize";
import "./group-container.scss";
import "./group-container-responsive.scss";
import SidebarLoader from "components/sidebar/sidebarLoader";
import { DisplayVariant } from "containers/Library/Community/domain";
import { PurchaseTypes } from "containers/AppPurchase/domain";
import { ContentType, LibraryType } from "containers/Library/Admin/domain";
import miscUtils from "utils/miscUtils";
import moment from "moment";
import { SSOMethod } from "containers/IntegrationsContainer/SingleSignOn/domain";
import useSlideoutProfile from "hooks/slideoutProfileHook";
import { CATEGORY_TYPE } from "enums";
import VerifyAccountComponent from "containers/selfSignup/VerifyAccountComponent";
import NotFound from "containers/notFound";
import { useAtom } from "jotai";
import { activeSubReloadAtom, communityBillingPlansPopupAtom, showActiveCHatAtom, showBannerAtom, showMessagePopUpAtom, showUpgradeBannerAtom } from "showMessageMenuAtom";
import SignUpDisabled from "components/SignUpDisabled";
import {
  useQuery,
  useQueryClient,
} from 'react-query';
import CommunityService from "api/react-query/services/CommunityService";
import PlanDisabled from "components/PlanDisabled";
import Gleap from 'gleap';
import appConfig from "appConfig";
import AdminMemberDetailsPopUp from "containers/AdminMemberDetailsPopUp";
import CompletedQuiz from "containers/Library/Community/Courses/CompletedQuiz/CompletedQuiz";
import CommunityOnboardingSteps from "containers/CommunityOnboardingSteps";
import { GroupService } from "api/services/groups";
import { getlocalStorageValue, setlocalStorageValue } from "utils/localStorage";
import { toast, } from "react-toastify";
import CommunityBillingPopup from "components/CommunityBillingPopup/CommunityBillingPopup";
import { AsyncGroupPricing } from "containers/groupSettings/ AsyncComponentsCollection";
import { BillingService } from "api/services/billing";
import { AppContext } from "containers/main/MainComponent";
import { PostService } from "api/services/post";
import OnboardingService from "api/services/onboarding";
import { UserService } from "api/services/users";
import { useHistory, useLocation } from "react-router";
import AdminGettingStartedRighSideBar from "containers/AdminGettingStartedRIghtSideBar/AdminGettingStartedLeftSideBar";
import DefaultLandingPage from "containers/DefaultLandingPage";

const OWNER_ROLE_ID: number = 1;
const ONBOARDING_MESSAGE_COOKIE: string = "onboarding-message";

const AsyncGroupView: any = Loadable({
  loader: () => import("containers/groupView"),
  loading: MainLoadingComponent
});

const AsyncGroupSettings: any = Loadable({
  loader: () => import("containers/groupSettings"),
  loading: MainLoadingComponent
});

const AsyncSinglePost: any = Loadable({
  loader: () => import("containers/singlePost"),
  loading: MainLoadingComponent
});

const AsyncHome: any = Loadable({
  loader: () => import("containers/home"),
  loading: MainLoadingComponent
});

const AsyncRouterSwitch: any = Loadable({
  loader: () => import("containers/routerSwitch"),
  loading: MainLoadingComponent
});

const AsyncUnsubscribeNotifications: any = Loadable({
  loader: () => import("containers/unsubscribeNotifications"),
  loading: MainLoadingComponent
});

const AsyncGroupBillingCancellation: any = Loadable({
  loader: () => import("containers/groupBillingCancellation"),
  loading: MainLoadingComponent
});

const AsyncStripeCheck: any = Loadable({
  loader: () => import("containers/StripeCheck"),
  loading: MainLoadingComponent
});

const AsyncConfirmIntegration: any = Loadable({
  loader: () => import("containers/IntegrationsContainer/ConfirmIntegration"),
  loading: MainLoadingComponent
});

// const AsyncPlanSubscription: any = Loadable({
//   loader: () => import("containers/PlanSelection"),
//   loading: MainLoadingComponent
// });

const AsyncJoinGroup: any = Loadable({
  loader: () => import("containers/JoinGroup"),
  loading: MainLoadingComponent
});

const AsyncUserSubscriptions: any = Loadable({
  loader: () => import("containers/UserSubscriptions"),
  loading: MainLoadingComponent
});

const AsyncManageSubscription: any = Loadable({
  loader: () => import("containers/ManageSubscription"),
  loading: MainLoadingComponent
});

// const AsyncCourseAccess: any = Loadable({
//   loader: () => import("containers/CourseAccess"),
//   loading: MainLoadingComponent
// });

const AsyncLibraryContainer: any = Loadable({
  loader: () => import("containers/Library/Community"),
  loading: MainLoadingComponent
});

const AsyncLibraryItemDashboard: any = Loadable({
  loader: () => import("containers/Library/Community/LibraryItemDashboard"),
  loading: MainLoadingComponent
});

const AsyncLibraryCourseContainer: any = Loadable({
  loader: () => import("containers/Library/Community/LibraryCourseContainer"),
  loading: MainLoadingComponent
})

const AsyncLecturesContainer: any = Loadable({
  loader: () => import("containers/Library/Community/Courses/Lectures/LectureContainer"),
  loading: MainLoadingComponent
});

const AsyncGroupMembersPublic: any = Loadable({
  loader: () => import("containers/groupMembersPublic"),
  loading: MainLoadingComponent
});

const AsyncEventsContainer: any = Loadable({
  loader: () => import("containers/events/EventsCommunityContainer"),
  loading: MainLoadingComponent
});

const AsyncMembershipQuestionsPreview: any = Loadable({
  loader: () => import("containers/MembershipQuestions/MembershipQuestionsPreview"),
  loading: MainLoadingComponent,
});

const AsyncCourseIntro: any = Loadable({
  loader: () => import("containers/Library/Courses/CourseIntro"),
  loading: MainLoadingComponent,
});

const AsyncCategoryView: any = Loadable({
  loader: () => import("containers/Library/Community/ViewCategoryCommunity/ViewCategoryCommunity"),
  loading: MainLoadingComponent,
});


const AsyncAppPurchase: any = Loadable({
  loader: () => import("containers/AppPurchase"),
  loading: MainLoadingComponent,
});

const AsyncOAuthAuthorizationContainer: any = Loadable({
  loader: () => import("containers/OAuthAuthorizationContainer"),
  loading: MainLoadingComponent,
})

const AsyncGroupOnboarding: any = Loadable({
  loader: () => import("containers/createGroup/GroupOnboarding"),
  loading: MainLoadingComponent,
})

const AsyncGroupUpgradePrompt: any = Loadable({
  loader: () => import("containers/createGroup/GroupUpgradePrompt"),
  loading: MainLoadingComponent,
})

const AsyncFeedContainer: any = Loadable({
  loader: () => import("containers/FeedContainer"),
  loading: MainLoadingComponent,
})

const AsyncLivePageContainer: any = Loadable({
  loader: () => import("containers/PageBuilder/LivePageContainer"),
  loading: MainLoadingComponent,
})

const AsyncLivePagePreviewContainer: any = Loadable({
  loader: () => import("containers/PageBuilder/LivePagePreviewContainer"),
  loading: MainLoadingComponent,
})

const AsyncNewCommunityLandingPage: any = Loadable({
  loader: () => import("containers/landingPage/NewCommunityLandingPage"),
  loading: MainLoadingComponent,
})


const GroupContainer: React.FC<IGroupContainerProps> = props => {

  const adminTrackingRef = React.useRef<boolean>(false);

  const location = useLocation();
  const history = useHistory();

  const appContext = useContext(AppContext);
  const { group} = appContext;
  const [showBanner,] = useAtom(showBannerAtom);
  const [showUpgradeBanner,] = useAtom(showUpgradeBannerAtom);


  const windowSize = useWindowSize();
  const [currentGroup, getCurrentGroup] = useState<any>();
  const [isSideBar, setIsSideBar] = useState<any>(false);
  const [currentChannel, getCurrentChannel] = useState<any>();
  const [preview, setPreview] = useState<any>();
  const [isInvite, setIsInvite] = useState<boolean>(false);
  const [sideBarIsOpen, setSideBarIsOpen] = useState<string>("");
  const [publicSideBarIsOpen, setPublicSideBarIsOpen] = useState<string>("");
  const [onCourseLecturePage, setOnCourseLecturePage] = useState<string>("");
  const [newUserClass, setNewUserClass] = useState<string>("");
  const [membersPageClass, setMembersPageClass] = useState<string>("");
  const [memberCommunityUnreadCount,] = useState<number>(0);

  //membership screening
  const [isScreeningPopupOpen, setIsScreeningPopupOpen] = useState<boolean>(false);
  const [userHasScreened,] = useState<boolean>(false);
  const [isOnboarding, setIsOnboarding] = useState<boolean>(false);

  const [plan, setPlan] = useState<any>([]);
  const [, setSelectedPlan] = useState<any>();

  const [loadingCustomizedPosts, setLoadingCustomizedPosts] = React.useState<boolean>(true);
  const [customizedPostsData, setCustomizedPostsData] = React.useState<any>(null);
  const [, setLoadingHomePageConfigDetails] = React.useState<boolean>(true);
  const [homePageConfigDetails, setHomePageConfigDetails] = React.useState<any>(null);
  const [, setLoadingUserCourses] = React.useState<boolean>(true);
  const [userCourses, setUserCourses] = React.useState<any>(null);

  const {
    isAuthed,
    subdomain,
    global,
    groups: { userGroups },
    toggleHamburgerMenu,
    closeHamburgerMenu,
    openHamburgerMenu,
    globalUser,
    setCommunityFavicon,
    updateUser,
  } = props;

  const { closeSlideout } = useSlideoutProfile();

  const queryClient = useQueryClient();

  const getCommunityQuery = useQuery(
    [CommunityService.keyIds.GET_COMMUNITY, currentGroup || subdomain],
    CommunityService.queryFunctions.getCommunity,
    {
      initialData: appContext.group,
      enabled: false,
    }
  );

  // community billing plans pop up
  const [communityBillingPlansPopup, setCommunityBillingPlansPopup] = useAtom(communityBillingPlansPopupAtom) as any;

  const updateCommunityData = (updatedCommunityData: any) => {
    queryClient.setQueryData(
      [CommunityService.keyIds.GET_COMMUNITY, currentGroup || subdomain],
      updatedCommunityData,
    )
  }

  function getSelectedPlan(plan: any) {
    setSelectedPlan(plan);
  }

  function getPlans() {
    BillingService.getInstance()
      .getPlans()
      .then((plans: any) => {
        if (plans)
          setPlan(plans.data)
      }
      ).catch((error: any) => console.error(error))
  }

  useEffect(() => {
    if(
      getCommunityQuery.data &&
      appContext.groupMembershipData
    ) {
      updateCommunityData({
        ...getCommunityQuery.data,
        user_membership: appContext.groupMembershipData,
      });
    }
  }, [appContext.groupMembershipData]);

  useEffect(() => {
    if(getCommunityQuery.data) {
      // appContext.setGroup(getCommunityQuery.data);
    }
    if (
      getCommunityQuery.data &&
      getCommunityQuery.data.user_membership &&
      miscUtils.isAdmin(getCommunityQuery.data.user_membership)
    ) {
      loadSegmentAnalytics();
    }
  }, [getCommunityQuery.data]);

  useEffect(() => {
    if (miscUtils.isSubscriptionPaymentCanceled(getCommunityQuery.data) && !activeSubReload) {
      const redirectUrl: string =
        miscUtils.subscriptionHasActivePreviousPlan(getCommunityQuery.data) ?
        `plan-subscription/checkout?plan=${getCommunityQuery.data.user_membership.previous_plan.uuid}` :
        `plan-subscription`;

      if (subdomain) {
        props.history.push(`/${redirectUrl}`);
      } else {
        props.history.push(`/group/${props.group.slug}/${redirectUrl}`);
      }
      return;
    }
      
    if (miscUtils.isSubscriptionPaymentFailedOrPastDue(getCommunityQuery.data)) {
      if (subdomain) {
        props.history.push(`/plan-subscription/checkout`);
      } else {
        props.history.push(`/group/${props.group.slug}/plan-subscription/checkout`);
      }
      return;
    }
    
    if(
      window.location.pathname === "/" &&
      getCommunityQuery.data &&
      getCommunityQuery.isFetched
    ) {
      if(miscUtils.getDefaultCommunityPage(getCommunityQuery.data.default_page, miscUtils.getDefaultPageKey(isAuthed, getCommunityQuery.data), getCommunityQuery.data) === "/") {
        appContext.setShowDefaultLandingPage(true);
        return;
      }
      
      if(!(miscUtils.getDefaultCommunityPage(getCommunityQuery.data.default_page, miscUtils.getDefaultPageKey(isAuthed, getCommunityQuery.data), getCommunityQuery.data)).startsWith("/")) {
        window.open(miscUtils.getDefaultCommunityPage(getCommunityQuery.data.default_page, miscUtils.getDefaultPageKey(isAuthed, getCommunityQuery.data), getCommunityQuery.data), '_self');
        return;
      }

      setTimeout(() => {
        history.push(miscUtils.getDefaultCommunityPage(getCommunityQuery.data.default_page, miscUtils.getDefaultPageKey(isAuthed, getCommunityQuery.data), getCommunityQuery.data));
      }, 100);
    }
  }, [isAuthed, getCommunityQuery.data, getCommunityQuery.isFetched, window.location.pathname]);

  useEffect(() => {
    if (
      //@ts-ignore
      window.analytics
    ) {
      //@ts-ignore
      window.analytics.page();

      if (
        !adminTrackingRef.current &&
        getCommunityQuery.data &&
        getCommunityQuery.data.user_membership &&
        miscUtils.isAdmin(getCommunityQuery.data.user_membership)
      ) {
        adminTrackingRef.current = true;
        //@ts-ignore
        window.analytics.identify(getCommunityQuery.data.user_membership.user.id, {
          name: getCommunityQuery.data.user_membership.user.full_name,
          email: getCommunityQuery.data.user_membership.user.email,
        });
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    if (
      getCommunityQuery.data &&
      getCommunityQuery.data.user_membership &&
      getCommunityQuery.data.user_membership.user &&
      !getCommunityQuery.data.user_membership.user.full_name
    ) {
      props.history.push('/new-name')
    }

    if (
      getCommunityQuery.data &&
      getCommunityQuery.data.user_membership &&
      getCommunityQuery.data.user_membership.user
    ) {
      updateUser(getCommunityQuery.data.user_membership.user);
    }
  }, [getCommunityQuery.data && getCommunityQuery.data.id]);


  useEffect(() => {
    // if (
    //   props.uid &&
    //   globalUser &&
    //   getCommunityQuery.data
    // ) {
    //   getCustomizedPosts();
    // }

    // if (
    //   !props.uid &&
    //   !globalUser &&
    //   getCommunityQuery.data
    // ) {
    //   getOpenPosts();
    // }

    if (
      props.uid &&
      getCommunityQuery.data &&
      globalUser &&
      !userCourses
    ) {
      getUserCourses();
    } else {
      setLoadingUserCourses(false);
    }
  }, [getCommunityQuery.data && getCommunityQuery.data.id, globalUser]);

  const getOpenOrCustomizedPosts = (skipLoading?: boolean) => {
      if (
        props.uid &&
        globalUser &&
        getCommunityQuery.data
      ) {
        getCustomizedPosts(skipLoading);
      }
  
      if (
        !props.uid &&
        !globalUser &&
        getCommunityQuery.data
      ) {
        getOpenPosts(skipLoading);
      }
  }

  useEffect(() => {
    if(window.location.pathname === "/feed") {
      getOpenOrCustomizedPosts();
    }
  }, [window.location.pathname, getCommunityQuery.data && getCommunityQuery.data.id])

  useEffect(() => {
    if (
      !homePageConfigDetails
      && canGetConfigDetails()
    ) {
      getHomePageConfigDetails();
    } else {
      setLoadingHomePageConfigDetails(false);
    }
  }, [getCommunityQuery.data && getCommunityQuery.data.id, getCommunityQuery.data && getCommunityQuery.data.user_membership, homePageConfigDetails, window.location.pathname]);

  useEffect(() => {

    if (
      getCommunityQuery.data &&
      miscUtils.isTeamMember(getCommunityQuery.data.user_membership)
    ) {
      Gleap.initialize(appConfig.gleap.api_key as string);
      Gleap.identify(`${getCommunityQuery.data.user_membership.user.id}`, {
        name: getCommunityQuery.data.user_membership.user.full_name,
        email: getCommunityQuery.data.user_membership.user.email,
      });
    }
  }, [getCommunityQuery.data]);

  useEffect(() => {
    closeSlideout();
    getPlans();
  }, [])

  useLayoutEffect(() => {
    if (
      window.location.href.includes('invite?signup=true') &&
      getCommunityQuery.data &&
      getCommunityQuery.data.sso_enabled &&
      getCommunityQuery.data.sso_type === SSOMethod.OAUTH
    ) {
      props.history.push('/signin');
    }
  }, [window.location.href, getCommunityQuery.data]);

  useEffect(() => {
    setIsOnboarding(getCommunityQuery.data && isAuthed && miscUtils.isAdmin(getCommunityQuery.data.user_membership) && window.location.pathname === "/onboarding")
  }, [getCommunityQuery.data, window.location.pathname, isAuthed])

  // when a member Reactivating a subscription, we refetch group data
  const [activeSubReload, setActiveSubReload] = useAtom(activeSubReloadAtom);

  useEffect(() => {
    // getGroup();
    getCommunityQuery.refetch();
    return () => {
      setTimeout(() => {
        setActiveSubReload(false)
      }, 3000)
    }
  }, [isAuthed, activeSubReload]);

  useEffect(() => {
    if (
      getCommunityQuery.data &&
      getCommunityQuery.data.user_membership &&
      getCommunityQuery.data.user_membership.role_id === OWNER_ROLE_ID &&
      validTimeFromCommunityCreation() &&
      getCookieValue(ONBOARDING_MESSAGE_COOKIE) !== getCommunityQuery.data.id
    ) {
      setCookieValue(ONBOARDING_MESSAGE_COOKIE, getCommunityQuery.data.id);
    }
  });

  useEffect(() => {
    if ((window.location.pathname === "/invite" || window.location.pathname === "/invite-preview") && !isAuthed) {
      setIsInvite(true);
    } else {
      setIsInvite(false);
      if (getCommunityQuery.data && getCommunityQuery.data.plans.length === 1 && getCommunityQuery.data.plans[0].name === "free") {
        setIsInvite(false);
      }
    }

    if (window.location.pathname.includes("/members")) {
      setMembersPageClass("community-members-page");
    } else {
      setMembersPageClass("");
    }

    const query = new URLSearchParams(props.location.search);
    const invite = query.get("invite");
    if (invite && invite === "true") {
      setIsInvite(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location.pathname]);

  useEffect(() => {
    if (userGroups
      && !window.location.pathname.includes('group_billing_cancellation')
      && !window.location.pathname.includes('purchase')
      // && window.location.pathname !== "/onboarding"
    ) {
      if (
        (userGroups.data.length === 0 && window.location.pathname === '/' && !subdomain)
        // || (props.location.pathname.split("/")[1] === "posts" && !currentChannel) // Removed this so side bar can show on not found/ access restricted page for single post.
        || isOnboarding
        || window.location.pathname === "/upgrade"
      ) {
        setPreview("");
        setNewUserClass("empty-user-groups");
      } else {
        setPreview("channel-preview");
        setNewUserClass("");
      }
    } else {
      if (!isInvite
        && window.location.pathname !== '/signin'
        && !window.location.pathname.includes('group_billing_cancellation')
        && !window.location.pathname.includes('purchase')
        && !isOnboarding
        && window.location.pathname !== "/upgrade"
      ) {
        setPreview("channel-preview");
      } else {
        if (window.location.pathname.includes('purchase')) {
          // const pathParts = window.location.pathname.split('/')
          // if (
          //   (pathParts[2] && pathParts[2].includes('purchase')) &&
          //   ((pathParts[3] && !pathParts[3].includes('purchase')) || !pathParts[3])
          // ) {
          //   setPreview("channel-preview");
          // } else {
          //   setPreview("")
          // }

          if (window.location.pathname.split("/").pop() === "purchase") {
            setPreview("")
          } else {
            setPreview("channel-preview");
          }
        } else {
          setPreview("");
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userGroups, currentChannel, isInvite, props.location.pathname, window.location.pathname, isOnboarding]);

  useEffect(() => {
    if (
      (window.location.pathname.includes("library") || window.location.pathname.includes("courses")) &&
      window.location.pathname.includes("/lectures")
    ) {
      // toggleHamburgerMenu();
      // setOnCourseLecturePage("res-course-lecture");
    } else {
      setOnCourseLecturePage("");
    }

    if (window.innerWidth > 700
      && !window.location.pathname.includes('group_billing_cancellation')
      && !window.location.pathname.includes('purchase')
      && (window.location.pathname !== '/' && !subdomain)
    ) {
      setSideBarIsOpen("sidebar-is-open");

      if (
        !isAuthed &&
        !isInvite &&
        window.location.pathname !== '/signin' &&
        !isOnboarding &&
        window.location.pathname !== "/upgrade"
      ) {
        setPublicSideBarIsOpen("sidebar-channel-only-wrap-is-open");
      } else {
        setPublicSideBarIsOpen("");
      }
    } else {
      setSideBarIsOpen("");
    }

    if (window.location.pathname === '/signin') {
      setPreview("")
    }
  }, [props.location.pathname, isInvite]);

  useEffect(() => {
    if (
      ((window.location.pathname.includes("/library") || window.location.pathname.includes("/courses")) &&
        window.location.pathname.includes("/lectures")) ||
      window.location.pathname.split("/").pop() === "purchase" ||
      window.location.pathname.split("/")[1] === "pages" ||
      window.location.pathname.split("/")[1] === "pages-preview"
    ) {
      setTimeout(() => {
        closeHamburgerMenu();
      }, 100);
    }

    if (!isAuthed && !getCookieValue("sidebar") && window.location.pathname === "/" && windowSize.width > 991) {
      setTimeout(() => {
        openHamburgerMenu();
      }, 100)
    }
  }, [props.location.pathname]);

  useEffect(() => {
    if (
      (global.toggleSidebar
        && !window.location.pathname.includes('group_billing_cancellation')
        && ((window.location.pathname === '/' && subdomain !== null)
          || (window.location.pathname !== '/' && subdomain !== undefined)
        ))
    ) {
      setSideBarIsOpen("sidebar-is-open");
    } else {
      setSideBarIsOpen("");
    }

    if (!isAuthed) {
      if (
        global.toggleSidebar &&
        !isInvite &&
        window.location.pathname !== '/signin' &&
        !isOnboarding &&
        window.location.pathname !== "/upgrade"
      ) {
        setPublicSideBarIsOpen("sidebar-channel-only-wrap-is-open");
      } else {
        setPublicSideBarIsOpen("");
      }
    }

    setIsSideBar(global.toggleSidebar);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [global.toggleSidebar, isInvite]);

  useEffect(() => {
    if (
      !window.location.pathname.split("/").includes("settings")
      && (!window.location.pathname.includes("/lectures") && window.location.pathname.includes("/library"))
      && window.innerWidth > 991
      && !isOnboarding
      && window.location.pathname !== "/upgrade"
    ) {
      setlocalStorageValue("sidebar", true);
    }

    if (window.location.pathname.split("/").pop() === "purchase" && preview === undefined) {
      setPreview("");
      closeHamburgerMenu();
    }

    if (
      window.location.pathname.split("/")[1] === "pages" ||
      window.location.pathname.split("/")[1] === "pages-preview"
    ) {
      setPreview("");
      closeHamburgerMenu();
    }
  }, [props.location.pathname]);

  useEffect(() => {
    if (window.location.pathname.includes("settings") && isSideBar) {
      setIsSideBar(false);
      toggleHamburgerMenu();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  useEffect(() => {
    if (currentGroup || subdomain) {
      // getCommunityQuery.refetch();

      if (props.location.pathname.includes("post")) {
        // getCommunityQuery.refetch();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentGroup, subdomain, props.location.pathname, isAuthed]);

  useEffect(() => {
    if (getCommunityQuery.data && isAuthed && miscUtils.isAdmin(getCommunityQuery.data.user_membership) && !getCommunityQuery.data.onboarding_completed) {
      props.history.push("/onboarding")
    }
    // if (group && group.user_membership && group.user_membership.unread_messages_count > 0) {
    //   setMemberCommunityUnreadCount(group.user_membership.unread_messages_count);
    // }
  }, [getCommunityQuery.data, isAuthed]);

  useEffect(() => {
    if (isAuthed) {
      if (global.toggleSidebar && getlocalStorageValue("sidebar") && !getlocalStorageValue("sidebar").value) {
        setlocalStorageValue("sidebar", true);
      }

      if (!global.toggleSidebar && getlocalStorageValue("sidebar") && getlocalStorageValue("sidebar").value) {
        setlocalStorageValue("sidebar", false);
      }
    }
  }, [global.toggleSidebar]);

  useEffect(() => {
    if (
      getCommunityQuery.data &&
      !global.selectedGroup
    ) {
      store.store.dispatch(globalActions.setSelectedGroup(getCommunityQuery.data));
    }
  }, [getCommunityQuery, global]);

  const loadSegmentAnalytics = () => {
    //@ts-ignore
    if (window.analytics) return; // Prevent duplicate script insertion

    const innerHTML: string = process.env.REACT_APP_ENV === "production" ?
      `!function(){var i="analytics",analytics=window[i]=window[i]||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","screen","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware","register"];analytics.factory=function(e){return function(){if(window[i].initialized)return window[i][e].apply(window[i],arguments);var n=Array.prototype.slice.call(arguments);if(["track","screen","alias","group","page","identify"].indexOf(e)>-1){var c=document.querySelector("link[rel='canonical']");n.push({__t:"bpc",c:c&&c.getAttribute("href")||void 0,p:location.pathname,u:location.href,s:location.search,t:document.title,r:document.referrer})}n.unshift(e);analytics.push(n);return analytics}};for(var n=0;n<analytics.methods.length;n++){var key=analytics.methods[n];analytics[key]=analytics.factory(key)}analytics.load=function(key,n){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.setAttribute("data-global-segment-analytics-key",i);t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r);analytics._loadOptions=n};analytics._writeKey="CnPyTZJu68eprCdFKroeeO5AmyIRZZgl";;analytics.SNIPPET_VERSION="5.2.0";
      analytics.load("CnPyTZJu68eprCdFKroeeO5AmyIRZZgl");
      analytics.page();
      }}();` :
      `!function(){var i="analytics",analytics=window[i]=window[i]||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","screen","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware","register"];analytics.factory=function(e){return function(){if(window[i].initialized)return window[i][e].apply(window[i],arguments);var n=Array.prototype.slice.call(arguments);if(["track","screen","alias","group","page","identify"].indexOf(e)>-1){var c=document.querySelector("link[rel='canonical']");n.push({__t:"bpc",c:c&&c.getAttribute("href")||void 0,p:location.pathname,u:location.href,s:location.search,t:document.title,r:document.referrer})}n.unshift(e);analytics.push(n);return analytics}};for(var n=0;n<analytics.methods.length;n++){var key=analytics.methods[n];analytics[key]=analytics.factory(key)}analytics.load=function(key,n){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.setAttribute("data-global-segment-analytics-key",i);t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r);analytics._loadOptions=n};analytics._writeKey="ahUCsRB2GDNeIXPGogNvcks7jfNaMyqL";;analytics.SNIPPET_VERSION="5.2.0";
      analytics.load("ahUCsRB2GDNeIXPGogNvcks7jfNaMyqL");
      analytics.page();
      }}();`;

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = innerHTML;

    document.head.appendChild(script);
  }

  const getCustomizedPosts = (skipLoading?: boolean) => {
    if (getCommunityQuery.data && getCommunityQuery.data.id && globalUser) {
      if(!skipLoading) {
        setLoadingCustomizedPosts(true);
      }
      PostService.getInstance()
        .getCustomizedPosts(getCommunityQuery.data.id, props.uid)
        .then((response: any) => {
          setLoadingCustomizedPosts(false);
          setCustomizedPostsData(
            {
              data: response.data,
              ...(response.meta || {}),
              next_page_url: response.links.next,
            }
          );
        }).catch((error: any) => {
          console.error(error)
          new Error(error)
        })
        .finally(() => setLoadingCustomizedPosts(false));
    }
  }

  const getOpenPosts = (skipLoading?: boolean) => {
    if(!skipLoading) {
      setLoadingCustomizedPosts(true);
    }
    PostService.getInstance()
      .getOpenPosts(getCommunityQuery.data.id)
      .then((response: any) => {
        setLoadingCustomizedPosts(false);
        setCustomizedPostsData({
          data: response.data,
          ...(response.meta || {}),
          next_page_url: response.links.next,
        });
      }).catch((error: any) => {
        console.error(error)
        new Error(error)
      })
      .finally(() => setLoadingCustomizedPosts(false));
  }

  const canGetConfigDetails = () => {
    return (
      getCommunityQuery.data &&
      getCommunityQuery.data.user_membership &&
      miscUtils.isActiveCommunityMember(getCommunityQuery.data.user_membership)
    )
  }

  const getHomePageConfigDetails = () => {
    if (getCommunityQuery.data) {
      setLoadingHomePageConfigDetails(true);
      OnboardingService.getInstance()
        .getHomePageConfigDetails(getCommunityQuery.data.id)
        .then((response: any) => {
          setLoadingHomePageConfigDetails(false);
          setHomePageConfigDetails(response && response.data);
        }).catch((error: any) => {
          console.error(error)
          new Error(error)
        })
        .finally(() => setLoadingHomePageConfigDetails(false));
    }
  }

  const getUserCourses = () => {
    setLoadingUserCourses(true);
    UserService.getInstance()
      .getUserLibraryContentsSnapshot(props.uid, getCommunityQuery.data.id, LibraryType.COURSE, `&limit=6`)
      .then((response: any) => {
        setLoadingUserCourses(false);
        setUserCourses(response.data);
      }).catch((error: any) => {
        console.error(error)
        new Error(error)
      })
      .finally(() => setLoadingUserCourses(false));
  }

  function getGroupFromSinglePostPage(group: any) {
    getCurrentGroup(group);
  }

  function getChannelFromSinglePostPage(channel: any) {
    getCurrentChannel(channel);
  }

  const search = props.location.search;
  // @ts-ignore
  // eslint-disable-next-line
  const params = new URLSearchParams(search);

  function toggleInvite() {
    setIsInvite(false);
  }

  const shouldSidebarLoaderShow = (): boolean => {
    return (
      subdomain && getCommunityQuery.isLoading && (window.location.pathname.split('/')[1] !== 'posts') &&
      (window.location.pathname.split("/")[1] !== "pages") &&
      (window.location.pathname.split("/")[1] !== "pages-preview") &&
      (!window.location.pathname.includes("plan-subscription")) &&
      (!window.location.pathname.includes("sso/oauth/callback")) &&
      (!window.location.pathname.includes("plan-subscription-preview")) &&
      (!window.location.pathname.includes("membership-questions-preview")) &&
      (window.location.pathname.split("/").pop() !== "purchase") &&
      (!(window.location.pathname.includes("library") && window.location.pathname.includes("/lectures") && window.location.pathname.includes("/view"))) &&
      (!(window.location.pathname.includes("courses") && window.location.pathname.includes("/lectures"))) &&
      (window.location.pathname.split("/").pop() !== "invite") &&
      (window.location.pathname.split("/").pop() !== "invite-preview") &&
      (window.location.pathname.split("/").pop() !== "signin") &&
      (!(!props.uid && (window.location.pathname.split("/").length === 3 || window.location.pathname.split("/").length === 4) && (window.location.pathname.split("/")[1] === "courses" || window.location.pathname.split("/")[1] === "library")))
      && !isOnboarding
      && window.location.pathname !== "/upgrade"
    )
  }


  const validTimeFromCommunityCreation = (): boolean => {
    const allowedDifferenceInMinutes: number = 1;
    const communityCreationDate = moment.utc(getCommunityQuery.data.created_at);
    const currentTime = moment.utc();

    return currentTime.diff(communityCreationDate, 'minutes') <= allowedDifferenceInMinutes;
  }

  const userIsAnAuthorizedAdmin = (): boolean => {
    return (
      getCommunityQuery.data &&
      getCommunityQuery.data.user_membership &&
      miscUtils.isTeamMember(getCommunityQuery.data.user_membership) &&
      !miscUtils.isModerator(getCommunityQuery.data.user_membership)
    )
  }

  const [, setOpenMessagePopUp] = useAtom(showMessagePopUpAtom);
  const [, setActiveChatroomMessage] = useAtom(showActiveCHatAtom);

  useEffect(() => {
    if (isAuthed) {
      if (window.location.search) {
        const messageParam = new URLSearchParams(window.location.search);
        const chatRoomID = messageParam.get("chatRoom");
        const messagePopUpOpen = messageParam.get("chatOpen");

        if (chatRoomID && messagePopUpOpen === "true") {
          const chatRoomIDNumber: any = Number(chatRoomID)
          setOpenMessagePopUp(true)
          document.body.style.overflow = 'hidden';
          setActiveChatroomMessage(chatRoomIDNumber)
        }
      }
    }
    else {
      // To avoid setting empty strings
      if (window.location.search) {
        setlocalStorageValue("next_link", window.location.search);
      }
    }

  }, [isAuthed, window.location.search]);

  const _groupData = getCommunityQuery && getCommunityQuery.data
  const _plan = miscUtils.getGroupPlan(_groupData)
  const planLimit = _plan.members


  function isWithinMemberLimit(totalMembersLimit: number, totalMembersCount: number, isAdmin: boolean) {
    // If the user being added is an admin, they should not count towards the limit
    const effectiveMemberCount = isAdmin ? totalMembersCount - 1 : totalMembersCount;

    // Check if the effective member count exceeds the limit
    return effectiveMemberCount < totalMembersLimit;
  }

  useEffect(() => {
    // redirect to people page if community has reached limit and the team member is logged in
    if (
      _groupData &&
      userId &&
      window.location.pathname !== '/settings/members' &&
      window.location.pathname !== '/settings/billing' &&
      window.location.pathname !== '/settings/billing/plans' &&
      !window.location.pathname.match(/settings\/billing\/plans\/[0-9]+\/confirmation/) &&
      _groupData.user_membership &&
      miscUtils.isTeamMember(_groupData.user_membership)
    ) {
      if (planLimit !== -1) {
        if (!isWithinMemberLimit(planLimit, _groupData.members_count, miscUtils.isTeamMember(_groupData.user_membership))) {
          props.history.push('/settings/members')
          setTimeout(() => {
            if (!communityBillingPlansPopup.open) {
              setCommunityBillingPlansPopup({
                open: true,
                title: `Members limit reached. Upgrade plan.`,
              });
            }
          }
            , 1000)
        }
      }
    }
  }, [_groupData, window.location.pathname])


  useEffect(() => {
    if (window.location.pathname === "/shopify-custom-installation") {
      if (isAuthed) {
        const getQueryParams = (): URLSearchParams => new URLSearchParams(window.location.search);
        const searchParams: any = getQueryParams();
        let params: any = {}
        for (let [key, value] of searchParams.entries()) {
          params[key] = value;
        }
        if (Object.keys(params).length > 0) {
          GroupService.getInstance()
            .shopifyCustomInstallation(params)
            .then((response: any) => {
              if (response) {
                window.open(response.authorization_url, "_self");
              }
            })
            .catch((error: any) => {
              toast(" Please try again later.", {
                type: 'error',
                autoClose: 3000,
                position: "top-center",
                hideProgressBar: true,
                theme: "light"
              });
              console.error(error)
            })
            .finally(() => {

            })
        }
      }
      else {
        let url = new URL(window.location.href)
        let pathandQuery = url.pathname + url.search;
        setlocalStorageValue("next_link", pathandQuery)
        props.history.push('/signin')
      }
    }

  }, [isAuthed, window.location.pathname]);

  // Onboarding steps section
  const [requiredDefaultKeys, setRequiredDefaultKeys] = useState<any>()
  const groupData = getCommunityQuery && getCommunityQuery.data
  const userId = props.uid
  const [isOnboardingStepsPopupOpen, setIsOnboardingStepsPopupOpen] = useState<boolean>(false);
  const [requiredDefaultFields, setRequiredDefaultFields] = useState<any>()
  const [requiredCustomFields, setRequiredCustomFields] = useState<any>()

  const newMemberCheck = miscUtils.newMemberCheck(userId, group)

  function getCommunityFieldsData() {
    GroupService.getInstance()
      .getCommunityFields(group && group.id, 'default')
      .then((response: any) => {
        if (response) {
          if (newMemberCheck) {
            const requiredResData = response.data && response.data.length > 0 &&
              response.data.filter((res: any) => ((res.required) || (res.ask_during_sign_up)));
            setRequiredDefaultFields(requiredResData)
          } else {
            const requiredResData = response.data && response.data.length > 0 &&
              response.data.filter((res: any) => res.required);
            setRequiredDefaultFields(requiredResData)
          }
        }
      }).catch((error: any) => console.error(error))
  }

  function customfields() {

    GroupService.getInstance()
      .getCommunityFields(group && group.id, 'custom')
      .then((response: any) => {
        if (response) {
          const requiredResData = response.data && response.data.length > 0 &&
            response.data.filter((res: any) => res.required);
          findQuestionsWithNullAnswers(group.user_membership.screening_response, requiredResData)

        }
      }).catch((error: any) => console.error(error))
  }

  // find required custom fields with null answers || 
  // find required custom fields that does not match groupData.user_membership.screening_response but is still required 
  function findQuestionsWithNullAnswers(array1: any, array2: any) {

    if (!array1) {
      setRequiredCustomFields(array2)
      return
    }

    const t = array2.filter((item2: any) => {
      // Condition 1: Check if item2's id doesn't exist in array1 with a non-empty answer
      const hasNoMatchingId = !array1.some((item1: any) =>
        item1.id === item2.id &&
        item1.answer !== null &&
        item1.answer.length > 0
      );

      // Condition 2: Check if for matching questions, the answer is empty/null
      const hasValidQuestionAnswer = array1.every((item1: any) => {
        if (item1.question === item2.name) {
          // If questions match, include only if answer is empty or null
          return item1.answer === null || item1.answer === '';
        }
        // Include if questions don't match
        return true;
      });

      // Item must satisfy both conditions
      return hasNoMatchingId && hasValidQuestionAnswer;
    });

    setRequiredCustomFields(t)
  }


  const _memberData = group && group.user_membership && group.user_membership.user

  useEffect(() => {
    if (
      // dont call on theses page
      (!window.location.pathname.includes('/plan-subscription')) &&
      (window.location.pathname !== '/upgrade') &&
      (!window.location.pathname.includes('/onboarding')) &&
      (!window.location.pathname.includes('/settings')) &&
      (!window.location.pathname.includes('/purchase')) &&
      group &&
      group.user_membership &&
      group.user_membership.user &&
      userId &&
      !miscUtils.isTeamMember(group.user_membership)
    ) {
      getCommunityFieldsData()
      if (!newMemberCheck) {

        customfields()
      }
    }
  }, [_memberData, group])


  useEffect(() => {
    const temprequiredDefaultFieldsList: any = []
    if (requiredDefaultFields !== null && requiredDefaultFields !== undefined && _memberData) {
      requiredDefaultFields.map((data: any) => {
        if (data.name === 'City' && _memberData.location === null) {
          temprequiredDefaultFieldsList.push('location')
        }
        if (data.name === 'Country' && _memberData.country_id === null) {
          temprequiredDefaultFieldsList.push('country_id')
        }
        if (data.name === 'Timezone' && _memberData.timezone_id === null) {
          temprequiredDefaultFieldsList.push('timezone_id')
        }
        if (data.name === 'Profile photo' && _memberData.profile_image === null) {
          temprequiredDefaultFieldsList.push('profile_image')
        }
        if (data.name === 'Headline' && _memberData.headline === null) {
          temprequiredDefaultFieldsList.push('headline')
        }
        if (data.name === 'Job title' && _memberData.job_title === null) {
          temprequiredDefaultFieldsList.push('job_title')
        }
        if (data.name === 'Bio' && _memberData.about_me === null) {
          temprequiredDefaultFieldsList.push('about_me')
        }
        if (data.name === 'Instagram' && _memberData.instagram === null) {
          temprequiredDefaultFieldsList.push('instagram',)
        }
        if (data.name === 'Facebook' && _memberData.facebook === null) {
          temprequiredDefaultFieldsList.push('facebook',)
        }
        if (data.name === 'LinkedIn' && _memberData.linkedin === null) {
          temprequiredDefaultFieldsList.push('linkedin')
        }
        if (data.name === 'Web URL' && _memberData.website === null) {
          temprequiredDefaultFieldsList.push('website')
        }
        if (data.name === 'X' && _memberData.twitter === null) {
          temprequiredDefaultFieldsList.push('twitter')
        }
        if (data.name.includes('Phone') && (_memberData.phone === null || _memberData.phone === '')) {
          temprequiredDefaultFieldsList.push('phone')
        }
      })
      setRequiredDefaultKeys(temprequiredDefaultFieldsList)
    }
  }, [requiredDefaultFields, group, _memberData])

  const prevPopUpStatesRef: any = React.useRef([]);

  useEffect(() => {
    prevPopUpStatesRef.current.push(isOnboardingStepsPopupOpen);
  }, [isOnboardingStepsPopupOpen]);

  
  useEffect(() => {
    const trueExists = prevPopUpStatesRef.current.includes(true);
    if (isAuthed && group && group.user_membership && requiredDefaultKeys) {
      if (trueExists) {
        return
      }
      else {
        const steps = miscUtils.onboardingPopUpShouldOpen(group, isAuthed, requiredDefaultKeys, requiredCustomFields)
        if (steps.length > 0) setIsOnboardingStepsPopupOpen(true)
      }
    }
  }, [group, isAuthed, requiredDefaultKeys, requiredCustomFields, appContext.group ])
  // end of  Onboarding steps section

  useEffect(() => {
    if (!isAuthed) {
      if ((
        window.location.pathname.split("/").length === 3 &&
        window.location.pathname.split("/")[1] === ContentType.COURSE //course outline page
      )) {
        setPreview("");
        closeHamburgerMenu();
      }

      if ((
        window.location.pathname.split("/").length === 3 &&
        window.location.pathname.split("/")[1] === 'events' //event view page
      )) {
        setPreview("");
        closeHamburgerMenu();
      }
    }
  }, [window.location.pathname, isAuthed]);

  useEffect(() => {
    if (!isAuthed) {
      if ((
        window.location.pathname.split("/").length === 3 &&
        window.location.pathname.split("/")[1] === 'events' && //event view page
        preview
      )) {
        setPreview("");
        closeHamburgerMenu();
      }
    }
  }, [isAuthed, preview]);


  if (
    getCommunityQuery.isLoading
  ) {
    return <></>
  }

  // if you are on articles view page and logout out, you should still see the sidebar
  const showSideBaronArticles = !isAuthed && window.location.pathname.includes('library/articles/lectures/view/')

  const isworkflowsEditPage = () => {
    return (
      (
        window.location.pathname.split("/")[2] === "workflows" &&
        window.location.pathname.split("/")[4] === "edit"
      )
    )
  }

  const updateCustomizedPost = (updatedPost: any) => {
    setCustomizedPostsData({
      ...customizedPostsData,
      data: customizedPostsData.data.map((post: any) => {
        if(post.id === updatedPost.id) {
          return ({
            ...post,
            ...updatedPost,
          })
        } else {
          return post;
        }
      }),
    });
  }

  return (
    <div
      id="groupapp-main-wrap-container"
      // style={isworkflowsEditPage() ? {
      //   maxWidth: 'unset !important'
      // } : {}}
      style={{
        marginTop: showBanner
          ?
          `calc(${miscUtils.getTopOffsetForMobile('SmartAppBanner') + 5}px + env(safe-area-inset-top))`
          :
          showUpgradeBanner.isOpen
            ?  window.innerWidth < 768 ? `calc(${miscUtils.getTopOffsetForMobile('UpgradePlanBanner') + 5}px + env(safe-area-inset-top))`: `calc(${miscUtils.getTopOffsetForMobile('UpgradePlanBanner')}px + env(safe-area-inset-top))`
            : '0',
        ...(isworkflowsEditPage() ? {
          maxWidth: 'unset !important'
        } : {})
      }}
      className={
        getCommunityQuery.data && !getCommunityQuery.isLoading
          ? isSideBar && (isAuthed || showSideBaronArticles) && !isInvite && !isOnboarding &&
            window.location.pathname !== "/upgrade"
            ? `main-wrap ${sideBarIsOpen} ${newUserClass} ${onCourseLecturePage} ${membersPageClass} ${window.location.pathname.split("/")[1] === "settings" ||
            window.location.pathname.includes("plan-subscription") ||
            window.location.pathname.includes("user-subscriptions") ||
            window.location.pathname.includes("manage-subscription") ||
            window.location.pathname.includes(
              "plan-subscription-preview"
            ) ||
            preview
            }`
            : `main-wrap ${newUserClass} ${publicSideBarIsOpen} ${window.location.pathname.split("/")[1] === "settings" ||
              window.location.pathname.includes("plan-subscription") ||
              window.location.pathname.includes("user-subscriptions") ||
              window.location.pathname.includes("manage-subscription") ||
              window.location.pathname.includes(
                "plan-subscription-preview"
              ) ||
              window.location.pathname.includes("membership-questions-preview") ||
              (window.location.pathname.includes("/lectures")) ||
              (window.location.pathname.includes("sso/oauth/callback"))
              ? null
              : preview
            }`
          : isSideBar
            && isAuthed
            && !window.location.pathname.includes("email_unsubscription")
            && !window.location.pathname.includes("group_billing_cancellation")
            ? `main-wrap ${sideBarIsOpen} ${newUserClass}`
            : `main-wrap `
      }
    >
      {shouldSidebarLoaderShow() &&
        (
          <SidebarLoader
          />
        )}
      {isAuthed && !getCommunityQuery.isLoading ? (
        <>
          {getCommunityQuery.data && !isInvite
            && window.location.pathname !== "/"
            && !window.location.pathname.includes("group_billing_cancellation")
            && !window.location.pathname.includes("email_unsubscription")
            && !window.location.pathname.includes("/sso/oauth/callback")
            && window.location.pathname.split("/")[1] !== "pages"
            && window.location.pathname.split("/")[1] !== "pages-preview"
            && !isOnboarding
            && window.location.pathname !== "/upgrade"
            // && window.location.pathname.split("/")[1] !== "about-preview"
            && (
              <>
                <SidebarComponent
                  subdomain={subdomain}
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  currentChannel={currentChannel}
                  memberCommunityUnreadCount={memberCommunityUnreadCount}
                  customizedPostsData={customizedPostsData}
                  homePageConfigDetails={homePageConfigDetails}
                  userCourses={userCourses}
                />
              </>
            )}
        </>
      ) : (
        <>
          {!isInvite
            && window.location.pathname !== "/"
            && !window.location.pathname.includes("group_billing_cancellation")
            && !window.location.pathname.includes("email_unsubscription")
            && !window.location.pathname.includes("/sso/oauth/callback")
            && !isOnboarding
            && window.location.pathname !== "/upgrade"
            && window.location.pathname.split("/")[1] !== "pages"
            && window.location.pathname.split("/")[1] !== "pages-preview"
            // && window.location.pathname.split("/")[1] !== "about-preview"
            &&
            getCommunityQuery.data && (
              <>
                {windowSize.width > 991 ? (
                  <SidebarComponent
                    subdomain={subdomain || (global && global.currentSlug)}
                    group={getCommunityQuery.data && getCommunityQuery.data}
                    currentChannel={currentChannel}
                    isSubdomain={subdomain ? true : false}
                    customizedPostsData={customizedPostsData}
                    homePageConfigDetails={homePageConfigDetails}
                    userCourses={userCourses}
                  />
                ) : (
                  <SidebarForChannelComponent
                    subdomain={subdomain || (global && global.currentSlug)}
                    group={getCommunityQuery.data && getCommunityQuery.data}
                    currentChannel={currentChannel}
                    isSubdomain={subdomain ? true : false}
                    customizedPostsData={customizedPostsData}
                    homePageConfigDetails={homePageConfigDetails}
                    userCourses={userCourses}
                  />
                )}
              </>
            )}
        </>
      )}
      <div 
      id="content-wrap" className={`content-wrap flex flex-justify-center ${!isAuthed && "no-auth center"} ${window.location.pathname.includes('channel') || window.location.pathname === "/" ? 'content-wrap--channel-view' : ''
        } ${(
          window.location.pathname.split('/')[1] === 'posts' ||
          window.location.pathname.split('/')[1] === 'pages' ||
          window.location.pathname.split('/')[1] === 'pages-preview' ||
          window.location.pathname.split('/')[1] === 'email_unsubscription'
        ) ? 'content-wrap--single-post' : ''
        } ${window.location.pathname === '/filter' ? 'content-wrap--search-view' : ''
        } ${window.location.pathname.split('/')[1] === 'pages' ?
          'content-wrap--landing-page' : ''
        }
        ${isworkflowsEditPage() ? 'content-wrap--landing-page' : ''}
        ${appContext.isSidebarEmptyRef.current ?
          'content-wrap--sidebar-empty' :
          ''
        }
        ${window.location.pathname === '/' ? 'content-wrap--home-page' : ''}
        `}
      >
        {!subdomain ? (
          <Switch>
            <Route
              authed={isAuthed}
              group={true}
              exact={true}
              path={"/group/:groupSlug/members"}
              render={() => <AsyncGroupMembersPublic
                authed={isAuthed}
                theme={global.theme}
                screeningState={{
                  userHasScreened,
                  isScreeningPopupOpen,
                  setIsScreeningPopupOpen,
                }}
              />}
            />
            {/* <PublicRoute
              exact={true}
              path="/group/:groupSlug?"
              group={getCommunityQuery.data}
              component={
                <AsyncGroupView
                  toggleInvite={toggleInvite}
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  getGroupFromSinglePostPage={getGroupFromSinglePostPage}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  loadingGroup={getCommunityQuery.isLoading}
                  fetchingGroup={getCommunityQuery.isFetching}
                  customizedPostsData={customizedPostsData}
                  homePageConfigDetails={homePageConfigDetails}
                  userCourses={userCourses}
                />
              }
            /> */}
            <PublicRoute
              exact={true}
              path="/group/:groupSlug/about-community"
              group={getCommunityQuery.data}
              component={
                <AsyncNewCommunityLandingPage
                group={getCommunityQuery.data}
                theme={global.theme}
                planUrl={undefined}
                user={globalUser}
                />
              }
            />
            <PublicRoute
              exact={true}
              path="/group/:groupSlug/home"
              group={getCommunityQuery.data}
              component={
                <AsyncGroupView
                  toggleInvite={toggleInvite}
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  getGroupFromSinglePostPage={getGroupFromSinglePostPage}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  loadingGroup={getCommunityQuery.isLoading}
                  fetchingGroup={getCommunityQuery.isFetching}
                  customizedPostsData={customizedPostsData}
                  homePageConfigDetails={homePageConfigDetails}
                  userCourses={userCourses}
                />
              }
            />
            <PublicRoute
              exact={true}
              path="/group/:groupSlug/about-preview"
              group={getCommunityQuery.data}
              component={
                userIsAnAuthorizedAdmin()
                  ?
                  <AsyncGroupView
                    toggleInvite={toggleInvite}
                    group={getCommunityQuery.data && getCommunityQuery.data}
                    getGroupFromSinglePostPage={getGroupFromSinglePostPage}
                    screeningState={{
                      userHasScreened,
                      isScreeningPopupOpen,
                      setIsScreeningPopupOpen,
                    }}
                    loadingGroup={getCommunityQuery.isLoading}
                    fetchingGroup={getCommunityQuery.isFetching}
                    customizedPostsData={customizedPostsData}
                    homePageConfigDetails={homePageConfigDetails}
                    userCourses={userCourses}
                  />
                  :
                  <NotFound user message="Unauthorized Page" />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/channel/:groupSlug/:channelId"
              component={
                <AsyncGroupView
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  getGroupFromSinglePostPage={getGroupFromSinglePostPage}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  loadingGroup={getCommunityQuery.isLoading}
                  fetchingGroup={getCommunityQuery.isFetching}
                  customizedPostsData={customizedPostsData}
                  homePageConfigDetails={homePageConfigDetails}
                  userCourses={userCourses}
                />
              }
            />
            <Route
              exact={false}
              path="/group/:groupSlug?/settings"
              component={AsyncGroupSettings}
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/posts/:id"
              component={
                <AsyncSinglePost
                  authed={isAuthed}
                  getGroupFromSinglePostPage={getGroupFromSinglePostPage}
                  getChannelFromSinglePostPage={getChannelFromSinglePostPage}
                  group={getCommunityQuery.data}
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/library/:libraryItemType/:libraryItemId/:id"
              component={
                <AsyncSinglePost
                  authed={isAuthed}
                  getGroupFromSinglePostPage={getGroupFromSinglePostPage}
                  getChannelFromSinglePostPage={getChannelFromSinglePostPage}
                  group={getCommunityQuery.data}
                  singlePostLibraryView
                />
              }
            />
            <PrivateRoute
              user={globalUser}
              authed={isAuthed}
              exact={true}
              path={"/"}
              group={getCommunityQuery.data && getCommunityQuery.data}
              component={<AsyncHome />}
            />
            <PublicRoute
              exact={false}
              group={getCommunityQuery.data}
              path="/email_unsubscription"
              component={<AsyncUnsubscribeNotifications isAuthed={isAuthed} />}
            />
            <PublicRoute
              exact={false}
              group={getCommunityQuery.data}
              path="/group/:groupSlug/group_billing_cancellation"
              component={userIsAnAuthorizedAdmin() ? (
                <AsyncGroupBillingCancellation isAuthed={isAuthed} subdomain={subdomain} group={getCommunityQuery.data} />
              ) : (
                <NotFound user message="Unauthorized Page" />
              )}
            />
            <PublicRoute
              exact={false}
              group={getCommunityQuery.data}
              path="/stripe-connect"
              component={
                <AsyncStripeCheck
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  subdomain={subdomain}
                />
              }
            />
            <PublicRoute
              exact={false}
              group={getCommunityQuery.data}
              path="/integration-authorized"
              component={
                <AsyncConfirmIntegration
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  subdomain={subdomain}
                />
              }
            />
            <PublicRoute
              exact={false}
              group={getCommunityQuery.data}
              path="/shopify-custom-installation"
              component={
                <AsyncConfirmIntegration
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  subdomain={subdomain}
                />
              }
            />
            <PublicRoute
              exact={false}
              group={getCommunityQuery.data}
              path="/kit-custom-installation"
              component={
                <AsyncConfirmIntegration
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  subdomain={subdomain}
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/group/:groupSlug?/plan-subscription"
              component={
                <AsyncAppPurchase
                  userId={props.uid}
                  group={props.group}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  purchaseType={PurchaseTypes.GROUP_PLANS}
                  theme={global.theme}
                  authed={isAuthed}
                  subdomain={subdomain}
                  updateCommunityData={updateCommunityData}
                />
              }
            />
            <PublicRoute
              exact={false}
              group={getCommunityQuery.data}
              path="/group/:groupSlug?/plan-subscription/checkout"
              component={
                <AsyncAppPurchase
                  userId={props.uid}
                  group={props.group}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  purchaseType={PurchaseTypes.GROUP_PLAN}
                  theme={global.theme}
                  authed={isAuthed}
                  subdomain={subdomain}
                  updateCommunityData={updateCommunityData}
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/group/:groupSlug?/pages-preview/:pageSlug"
              component={
                userIsAnAuthorizedAdmin() ?
                  <AsyncLivePagePreviewContainer
                    group={getCommunityQuery.data}
                    authed={isAuthed}
                    authedUser={globalUser}
                  />
                  :
                  <NotFound user message="Unauthorized Page" />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/group/:groupSlug?/pages/:pageSlug"
              component={
                <AsyncLivePageContainer
                  group={getCommunityQuery.data}
                />
              }
            />
            <PublicRoute
              exact={false}
              group={getCommunityQuery.data}
              path="/group/:groupSlug?/plan-subscription-preview"
              component={
                userIsAnAuthorizedAdmin() ?
                  <AsyncAppPurchase
                    userId={props.uid}
                    group={props.group}
                    screeningState={{
                      userHasScreened,
                      isScreeningPopupOpen,
                      setIsScreeningPopupOpen,
                    }}
                    purchaseType={PurchaseTypes.GROUP_PLANS}
                    theme={global.theme}
                    authed={isAuthed}
                    preview
                    subdomain={subdomain}
                    updateCommunityData={updateCommunityData}
                  />
                  :
                  <NotFound user message="Unauthorized Page" />
              }
            />
            <PublicRoute
              exact={false}
              group={getCommunityQuery.data}
              path="/group/:groupSlug?/manage-subscription"
              component={
                <AsyncManageSubscription
                  theme={global.theme}
                  userId={props.uid}
                  subdomain={subdomain}
                />
              }
            />
            <PublicRoute
              exact={false}
              group={getCommunityQuery.data}
              path="/user-subscriptions"
              component={
                <AsyncUserSubscriptions
                  userId={props.uid}
                  subdomain={subdomain}
                />
              }
            />
          </Switch>
        ) : (
          <Switch>
            <PublicRoute
              exact={false}
              group={getCommunityQuery.data}
              path="/email_unsubscription"
              component={<AsyncUnsubscribeNotifications isAuthed={isAuthed} />}
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/sso/oauth/callback"
              component={
                <AsyncOAuthAuthorizationContainer
                  group={getCommunityQuery.data && getCommunityQuery.data}
                />
              }
            />
            <PublicRoute
              exact={false}
              group={getCommunityQuery.data}
              path="/manage-subscription"
              component={
                <AsyncManageSubscription
                  theme={global.theme}
                  userId={props.uid}
                  subdomain={subdomain}
                />
              }
            />
            <PublicRoute
              authed={isAuthed}
              group={getCommunityQuery.data}
              exact={true}
              path="/invite"
              disableRedirect={true}
              component={
                <AsyncGroupView
                  subdomain={subdomain}
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  getGroupFromSinglePostPage={getGroupFromSinglePostPage}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  loadingGroup={getCommunityQuery.data}
                  fetchingGroup={getCommunityQuery.isFetching}
                  customizedPostsData={customizedPostsData}
                  homePageConfigDetails={homePageConfigDetails}
                  userCourses={userCourses}
                />
              }
            />
            <PublicRoute
              authed={isAuthed}
              group={getCommunityQuery.data}
              exact={true}
              path="/filter"
              disableRedirect={true}
              component={
                <AsyncGroupView
                  subdomain={subdomain}
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  getGroupFromSinglePostPage={getGroupFromSinglePostPage}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  loadingGroup={getCommunityQuery.data}
                  fetchingGroup={getCommunityQuery.isFetching}
                  customizedPostsData={customizedPostsData}
                  homePageConfigDetails={homePageConfigDetails}
                  userCourses={userCourses}
                />
              }
            />
            <PublicRoute
              exact={false}
              group={getCommunityQuery.data}
              path="/stripe-connect"
              component={
                <AsyncStripeCheck
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  subdomain={subdomain}
                />
              }
            />
            <PublicRoute
              exact={false}
              group={getCommunityQuery.data}
              path="/group_billing_cancellation"
              component={userIsAnAuthorizedAdmin() ? (
                <AsyncGroupBillingCancellation isAuthed={isAuthed} subdomain={subdomain} group={getCommunityQuery.data} />
              ) : (
                <NotFound user message="Unauthorized Page" />
              )}
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/plan-subscription"
              component={
                <AsyncAppPurchase
                  userId={props.uid}
                  group={props.group}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  purchaseType={PurchaseTypes.GROUP_PLANS}
                  theme={global.theme}
                  authed={isAuthed}
                  subdomain={subdomain}
                  updateCommunityData={updateCommunityData}
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/plan-subscription/checkout"
              component={
                <AsyncAppPurchase
                  userId={props.uid}
                  group={props.group}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  purchaseType={PurchaseTypes.GROUP_PLAN}
                  theme={global.theme}
                  authed={isAuthed}
                  subdomain={subdomain}
                  updateCommunityData={updateCommunityData}
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/pages-preview/:pageSlug"
              component={
                (
                  userIsAnAuthorizedAdmin() ||
                  miscUtils.moderatorHasAdditionalPerms(getCommunityQuery.data, 'read-write-landing-pages')
                ) ?
                  <AsyncLivePagePreviewContainer
                    group={getCommunityQuery.data}
                    authed={isAuthed}
                    authedUser={globalUser}
                  />
                  :
                  <NotFound user message="Unauthorized Page" />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/pages/:pageSlug"
              component={
                <AsyncLivePageContainer
                  group={getCommunityQuery.data}
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/plan-subscription-preview"
              component={
                userIsAnAuthorizedAdmin() ?
                  <AsyncAppPurchase
                    userId={props.uid}
                    group={props.group}
                    screeningState={{
                      userHasScreened,
                      isScreeningPopupOpen,
                      setIsScreeningPopupOpen,
                    }}
                    purchaseType={PurchaseTypes.GROUP_PLANS}
                    theme={global.theme}
                    authed={isAuthed}
                    preview
                    subdomain={subdomain}
                    updateCommunityData={updateCommunityData}
                  />
                  :
                  <NotFound user message="Unauthorized Page" />
              }
            />
            <PrivateRoute
              exact={false}
              path="/membership-questions-preview"
              group={getCommunityQuery.data && getCommunityQuery.data}
              component={
                <AsyncMembershipQuestionsPreview
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  theme={global.theme}
                />
              }
            />
            <PublicRoute
              exact={false}
              path="/user-subscriptions"
              group={getCommunityQuery.data}
              component={
                <AsyncUserSubscriptions
                  userId={props.uid}
                  subdomain={subdomain}
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/join_group/:inviteConfigSlug?"
              component={
                <AsyncJoinGroup
                  theme={global.theme}
                  userId={props.uid}
                />
              }
            />
            {/* <PublicRoute
              authed={isAuthed}
              group={getCommunityQuery.data}
              exact={true}
              path="/"
              disableRedirect={true}
              component={
                <AsyncGroupView
                  subdomain={subdomain}
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  getGroupFromSinglePostPage={getGroupFromSinglePostPage}
                  uid={props.uid}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  loadingGroup={getCommunityQuery.isLoading}
                  fetchingGroup={getCommunityQuery.isFetching}
                  customizedPostsData={customizedPostsData}
                  homePageConfigDetails={homePageConfigDetails}
                  userCourses={userCourses}
                />
              }
            /> */}
            <PublicRoute
              exact={true}
              path="/about-community"
              group={getCommunityQuery.data}
              component={
                <AsyncNewCommunityLandingPage
                group={getCommunityQuery.data}
                theme={global.theme}
                planUrl={undefined}
                user={globalUser}
                />
              }
            />
            <PublicRoute
              authed={isAuthed}
              group={getCommunityQuery.data}
              exact={true}
              path="/home"
              disableRedirect={true}
              component={
                <AsyncGroupView
                  subdomain={subdomain}
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  getGroupFromSinglePostPage={getGroupFromSinglePostPage}
                  uid={props.uid}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  loadingGroup={getCommunityQuery.isLoading}
                  fetchingGroup={getCommunityQuery.isFetching}
                  customizedPostsData={customizedPostsData}
                  homePageConfigDetails={homePageConfigDetails}
                  userCourses={userCourses}
                />
              }
            />
            <PublicRoute
              authed={isAuthed}
              group={getCommunityQuery.data}
              exact={true}
              path="/about-preview"
              disableRedirect={true}
              component={
                userIsAnAuthorizedAdmin()
                  ?
                  <AsyncGroupView
                    subdomain={subdomain}
                    group={getCommunityQuery.data && getCommunityQuery.data}
                    getGroupFromSinglePostPage={getGroupFromSinglePostPage}
                    uid={props.uid}
                    screeningState={{
                      userHasScreened,
                      isScreeningPopupOpen,
                      setIsScreeningPopupOpen,
                    }}
                    loadingGroup={getCommunityQuery.isLoading}
                    fetchingGroup={getCommunityQuery.isFetching}
                    customizedPostsData={customizedPostsData}
                    homePageConfigDetails={homePageConfigDetails}
                    userCourses={userCourses}
                  />
                  :
                  <NotFound user message="Unauthorized Page" />
              }
            />
            <PrivateRoute
              authed={isAuthed}
              exact={true}
              path={"/members"}
              group={getCommunityQuery.data && getCommunityQuery.data}
              component={
                <AsyncGroupMembersPublic
                  authed={isAuthed}
                  subdomain={subdomain}
                  group={getCommunityQuery.data}
                  theme={global.theme}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                />
              }
            />
            <PublicRoute
              exact={false}
              group={getCommunityQuery.data}
              path="/integration-authorized"
              component={
                <AsyncConfirmIntegration
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  subdomain={subdomain}
                />
              }
            />
            <PublicRoute
              exact={false}
              group={getCommunityQuery.data}
              path="/shopify-custom-installation"
              component={
                <AsyncConfirmIntegration
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  subdomain={subdomain}
                />
              }
            />
              <PublicRoute
              exact={false}
              group={getCommunityQuery.data}
              path="/kit-custom-installation"
              component={
                <AsyncConfirmIntegration
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  subdomain={subdomain}
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/courses"
              component={
                <AsyncLibraryCourseContainer
                  theme={global.theme}
                  subdomain={subdomain}
                  userId={props.uid}
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  displayVariant={DisplayVariant.COURSE}
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/library"
              component={
                <AsyncLibraryContainer
                  theme={global.theme}
                  subdomain={subdomain}
                  userId={props.uid}
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  displayVariant={DisplayVariant.STANDALONE}
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/courses/:contentId?"
              component={
                <AsyncCourseIntro
                  theme={global.theme}
                  subdomain={subdomain}
                  userId={props.uid}
                  user={globalUser}
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  isAuthed={isAuthed}
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/courses/categories/:categoryId?"
              component={
                <AsyncCategoryView
                  theme={global.theme}
                  subdomain={subdomain}
                  userId={props.uid}
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  isAuthed={isAuthed}
                  displayVariant={DisplayVariant.COURSE}
                  categoryType={CATEGORY_TYPE.COURSE}
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/library/categories/:categoryId?"
              component={
                <AsyncCategoryView
                  theme={global.theme}
                  subdomain={subdomain}
                  userId={props.uid}
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  isAuthed={isAuthed}
                  displayVariant={DisplayVariant.STANDALONE}
                  categoryType={CATEGORY_TYPE.LIBRARY_CONTENT}
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/courses/:courseId?/purchase"
              component={
                <AsyncAppPurchase
                  userId={props.uid}
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  purchaseType={PurchaseTypes.COURSE}
                  theme={global.theme}
                  authed={isAuthed}
                  subdomain={subdomain}
                  updateCommunityData={updateCommunityData}
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/library/:libraryItemType?/:libraryItemId?"
              component={
                <AsyncLibraryContainer
                  theme={global.theme}
                  subdomain={subdomain}
                  userId={props.uid}
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  displayVariant={DisplayVariant.STANDALONE}
                  singleContentDisplay
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/library/:libraryItemType?/:libraryItemId?/gallery"
              component={
                <AsyncLibraryItemDashboard
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  userId={props.uid}
                  authed={isAuthed}
                  user={globalUser}
                  theme={global.theme}
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/library/:libraryItemType?/:libraryItemId?/purchase"
              component={
                <AsyncAppPurchase
                  userId={props.uid}
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  purchaseType={PurchaseTypes.LIBRARY}
                  theme={global.theme}
                  subdomain={subdomain}
                  updateCommunityData={updateCommunityData}
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/courses/:courseId?/lectures/:contentId?"
              component={
                <AsyncLecturesContainer
                  theme={global.theme}
                  user={globalUser}
                  subdomain={subdomain}
                  userId={props.uid}
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  sideBarIsOpen={sideBarIsOpen}
                  toggleLectureMenuRef={props.toggleLectureMenuRef}
                  authed={isAuthed}
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/courses/:courseId/section/:sectionId/enrollment/:enrollmentId/completed-quiz/:quizId/submission/:submissionId"
              component={
                <CompletedQuiz group={getCommunityQuery.data} userId={props.uid} history={props.history} />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/library/:libraryItemType?/lectures/view/:libraryItemId?"
              component={
                <AsyncLecturesContainer
                  theme={global.theme}
                  user={globalUser}
                  subdomain={subdomain}
                  userId={props.uid}
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  screeningState={{

                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  sideBarIsOpen={sideBarIsOpen}
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/posts/:id"
              component={
                <AsyncSinglePost
                  authed={isAuthed}
                  getGroupFromSinglePostPage={getGroupFromSinglePostPage}
                  getChannelFromSinglePostPage={getChannelFromSinglePostPage}
                  group={getCommunityQuery.data}
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/library/:libraryItemType/:libraryItemId/:id"
              component={
                <AsyncSinglePost
                  authed={isAuthed}
                  getGroupFromSinglePostPage={getGroupFromSinglePostPage}
                  getChannelFromSinglePostPage={getChannelFromSinglePostPage}
                  group={getCommunityQuery.data}
                  singlePostLibraryView
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/channel/:channelId"
              disableRedirect={true}
              component={
                <AsyncGroupView
                  subdomain={subdomain}
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  getGroupFromSinglePostPage={getGroupFromSinglePostPage}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  loadingGroup={getCommunityQuery.isLoading}
                  fetchingGroup={getCommunityQuery.isFetching}
                  customizedPostsData={customizedPostsData}
                  homePageConfigDetails={homePageConfigDetails}
                  userCourses={userCourses}
                />
              }
            />
            <PrivateRoute
              user={globalUser}
              authed={isAuthed}
              exact={false}
              path="/settings"
              group={getCommunityQuery.data && getCommunityQuery.data}
              component={
                <AsyncGroupSettings
                  isAuthed={isAuthed}
                  subdomain={subdomain}
                  setCommunityFavicon={setCommunityFavicon}
                />
              }
            />
            <PublicRoute
              user={globalUser}
              authed={isAuthed}
              exact={false}
              group={getCommunityQuery.data}
              path="/events"
              component={
                <AsyncEventsContainer
                  subdomain={subdomain}
                  group={getCommunityQuery.data && getCommunityQuery.data}
                  theme={global.theme}
                  user={globalUser}
                  userId={props.uid}
                  screeningState={{
                    userHasScreened,
                    isScreeningPopupOpen,
                    setIsScreeningPopupOpen,
                  }}
                  authed={isAuthed}
                />
              }
            />
            <PublicRoute
              user={globalUser}
              authed={isAuthed}
              exact
              group={getCommunityQuery.data}
              path="/feed"
              component={
                <AsyncFeedContainer
                  user={globalUser}
                  group={getCommunityQuery.data}
                  theme={global.theme}
                  uid={props.uid}
                  loadingCustomizedPosts={loadingCustomizedPosts}
                  customizedPostsData={customizedPostsData}
                  setCustomizedPostsData={setCustomizedPostsData}
                  getCustomizedPosts={getCustomizedPosts}
                  onPostUpdated={updateCustomizedPost}
                  onPostRequest={(skipLoading?: boolean) => getOpenOrCustomizedPosts(skipLoading)}
                />
              }
            />
            <PublicRoute
              user={globalUser}
              authed={isAuthed}
              exact
              group={getCommunityQuery.data}
              path="/signup-disabled"
              component={
                <SignUpDisabled />
              }
            />
            <PublicRoute
              user={globalUser}
              authed={isAuthed}
              exact
              group={getCommunityQuery.data}
              path="/plan-disabled"
              component={
                <PlanDisabled />
              }
            />
            <PrivateRoute
              user={globalUser}
              authed={isAuthed}
              exact={true}
              path="/onboarding"
              group={getCommunityQuery.data && getCommunityQuery.data}
              component={
                <AsyncGroupOnboarding
                  group={getCommunityQuery.data && getCommunityQuery.data}
                />
              }
            />
            <PrivateRoute
              user={globalUser}
              authed={isAuthed}
              exact={true}
              path="/upgrade"
              group={getCommunityQuery.data && getCommunityQuery.data}
              component={
                <AsyncGroupUpgradePrompt
                  plans={plan}
                  group={getCommunityQuery.data && getCommunityQuery.data}
                />
              }
            />
            <PublicRoute
              exact={true}
              group={getCommunityQuery.data}
              path="/verify-email?s=false"
              component={
                <VerifyAccountComponent
                  // @ts-ignore
                  groupId={getCommunityQuery.data && getCommunityQuery.data.id}
                  CommuinityTheme={getCommunityQuery.data && getCommunityQuery.data.custom_branding}
                />
              }
            />
            <Route
              render={() => {
                return (
                  <AsyncRouterSwitch
                    switchToMain={true}
                    subdomain={subdomain}
                  />
                );
              }}
            />
          </Switch>
        )}
      </div>
      <>
        <AdminMemberDetailsPopUp group={getCommunityQuery.data} getCommunityQuery={getCommunityQuery} />

        {isAuthed && group && group.user_membership && requiredDefaultKeys &&
          <CommunityOnboardingSteps
            group={group}
            isOpen={isOnboardingStepsPopupOpen}
            setIsOpen={setIsOnboardingStepsPopupOpen}
            userId={props.uid}
            requiredDefaultKeys={requiredDefaultKeys}
            getCommunityQuery={getCommunityQuery}
            setRequiredDefaultKeys={setRequiredDefaultKeys}
            memberData={_memberData}
            requiredCustomFields={requiredCustomFields}
          />
        }
      </>
      <CommunityBillingPopup
        dialogID={'CommunityBillingPopUp'}
        DialogWidth='auto'
        closefn={() => setCommunityBillingPlansPopup({
          open: false,
          title: undefined,
        })}
        titleText={communityBillingPlansPopup.title}
        IsOpen={communityBillingPlansPopup.open}
        childrenComponents={
          <AsyncGroupPricing
            subdomain={subdomain}
            plans={plan}
            group={getCommunityQuery.data}
            getSelectedPlan={getSelectedPlan}
            isInApopUp={true}
            appendPlanUuid
          />
        }
      />
      {isAuthed && groupData && groupData.user_membership &&
        <AdminGettingStartedRighSideBar
          groupData={getCommunityQuery.data}
        refreshGroupInformations={() => getCommunityQuery.refetch()}
        />
      }
      {appContext.showDefaultLandingPage ? (
        <DefaultLandingPage
        group={getCommunityQuery.data}
        />
      ) : <></>}
    </div>
  );
};

const mapDispatchToProps = (dispatch: any, ownProps: IGroupContainerProps) => {
  return {
    toggleHamburgerMenu: () => dispatch(globalActions.toggleHamburgerMenu()),
    closeHamburgerMenu: () => dispatch(globalActions.closeHamburgerMenu()),
    openHamburgerMenu: () => dispatch(globalActions.openHamburgerMenu()),
    updateUser: (user: any) => dispatch(authorizeActions.updateUser(user)),
  };
};

const mapStateToProps = (state: Map<string, any>) => {
  const authorize = Map(state.get("authorize", {})).toJS() as any;
  const global = Map(state.get("global", {})).toJS() as any;
  const globalUser: any = state.getIn(["authorize", "user"]);
  const groups = Map(state.get("group", {})).toJS() as any;

  return {
    globalUser,
    global,
    groups,
    guest: authorize.guest,
    uid: authorize.uid,
    isAuthed: authorize.authed,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GroupContainer as any) as any
) as any;
